module.exports = {"pathContext":{"name":"MedicationsReportResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"medications","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"MedicationsReportItem","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totalCount","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-medications-report-result.json
// module id = 1865
// module chunks = 185121392984766